var HashTable = function () {
    this._hash = {};
    this.table = this._hash;
    this.add = function (key, value) {
        if (typeof (key) != "undefined") {
            if (this.contains(key) == false) {
                this._hash[key] = typeof (value) == "undefined" ? null : value;
                return true;
            }
            else
                return false;

        } else
            return false;
    }

    this.update = function (key, value) {
        if (typeof (key) != "undefined") {
            if (this.contains(key)) {
                this._hash[key] = typeof (value) == "undefined" ? null : value;
                return true;
            }
            else
                return false;

        } else
            return false;
    }

    this.remove = function (key) {
        delete this._hash[key];
    }

    this.count = function () {
        var i = 0;
        for (var k in this._hash)
            i++;
        return i;
    }

    this.items = function (key) {
        return this._hash[key];
    }

    this.keys = function (callback) {
        for (let hash in this._hash) {
            // callback(this.table[hash])
            callback(hash)
            //   console.log(hash + ": " + this.table[hash]);
        }
    }

    this.contains = function (key) {
        return typeof (this._hash[key]) != "undefined";
    }

    this.clear = function () {
        for (var k in this._hash) {
            delete this._hash[k];
        }
    }
}

export { HashTable }